export default __webpack_public_path__ + "src/img/good-to-know//article_teaser_sweet_dreams.jpg";